/**
 * Header padding sync.
 *
 * The Sol Cleanse site header (#lc-navigation) is position: fixed,
 * so it's removed from document flow. An inline script in the theme
 * compensates by setting #MainContent's padding-top to the header's
 * clientHeight — but it runs ONCE on initial page load with no resize
 * or font-swap re-measurement.
 *
 * The result: when the announcement bar text wraps, when web fonts
 * swap in and change line-height, or when the user resizes the
 * browser, the padding-top stays at the original (too-small) value
 * and content tucks behind the fixed header. On PDPs that shows up
 * as a half-clipped product title.
 *
 * This script keeps padding-top in sync continuously:
 *   - On DOMContentLoaded / window load
 *   - On window resize and orientation change
 *   - When web fonts finish loading (line-height shifts)
 *   - Whenever the header's measured height changes (ResizeObserver) —
 *     covers announcement bar copy swaps, multi-line wrap, etc.
 */
(function () {
  function sync() {
    var nav = document.querySelector('#lc-navigation');
    var main = document.querySelector('#MainContent');
    if (!nav || !main) return;
    var h = nav.getBoundingClientRect().height;
    if (h > 0) main.style.paddingTop = h + 'px';
  }

  // Initial run
  sync();

  // After DOM parsing finishes (header may not be fully laid out yet)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  }

  // After all subresources (images in the announcement bar etc.) load
  window.addEventListener('load', sync);

  // Re-sync on viewport changes
  window.addEventListener('resize', sync);
  window.addEventListener('orientationchange', sync);

  // Re-sync when web fonts swap in (Adobe_Jenson / Crimson_Pro can shift line-height)
  if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
    document.fonts.ready.then(sync);
  }

  // Continuous observer — handles dynamic announcement bar swaps,
  // multi-line wrap, sticky-on-scroll-up toggles, etc.
  if ('ResizeObserver' in window) {
    var attach = function () {
      var nav = document.querySelector('#lc-navigation');
      if (!nav) return;
      try {
        new ResizeObserver(sync).observe(nav);
      } catch (e) {
        /* no-op */
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attach);
    } else {
      attach();
    }
  }
})();
